"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcSize = void 0;
const helpers_1 = require("../../helpers");
const Icon_1 = require("./..");
const calcSize = (size) => {
    switch (size) {
        case Icon_1.ICON_SIZES.xxs:
            return helpers_1.SIZE_XXS;
        case Icon_1.ICON_SIZES.xs:
            return helpers_1.SIZE_XS;
        case Icon_1.ICON_SIZES.s:
            return helpers_1.SIZE_S;
        case Icon_1.ICON_SIZES.m:
            return helpers_1.SIZE_M;
        case Icon_1.ICON_SIZES.l:
            return helpers_1.SIZE_L;
        case Icon_1.ICON_SIZES.xl:
            return helpers_1.SIZE_XL;
        case Icon_1.ICON_SIZES.xxl:
            return helpers_1.SIZE_XXL;
        case Icon_1.ICON_SIZES.xxxl:
            return helpers_1.SIZE_XXXL;
        default:
            return helpers_1.SIZE_M;
    }
};
exports.calcSize = calcSize;
//# sourceMappingURL=calcSize.js.map